import styled from 'styled-components';

const ElevatedButton = styled.button`
  background: ${props => props.primary ? props.theme.buttonPrimary : props.theme.cardBackground};
  color: ${props => props.theme.text};
  border: 2px solid ${props => props.primary ? props.theme.buttonPrimary : props.theme.border};
  padding: ${props => {
    if (props.size === 'small') return '0.4rem 0.85rem';
    if (props.size === 'medium') return '0.55rem 1.1rem';
    if (props.large) return '0.75rem 1.5rem';
    return '0.5rem 1rem';
  }};
  font-size: ${props => {
    if (props.size === 'small') return '0.8rem';
    if (props.size === 'medium') return '0.9rem';
    if (props.large) return '1rem';
    return '0.875rem';
  }};
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  white-space: nowrap;

  &:hover {
    background: ${props => props.primary ? props.theme.buttonPrimaryHover : props.theme.borderLight};
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.16);
    border-color: ${props => props.primary ? props.theme.buttonPrimaryHover : props.theme.borderLight};
  }

  &:active {
    background: ${props => props.primary ? props.theme.buttonPrimaryHover : props.theme.background};
    transform: translateY(1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 1200px) {
    padding: ${props => {
      if (props.size === 'small') return '0.35rem 0.75rem';
      if (props.size === 'medium') return '0.5rem 1rem';
      if (props.large) return '0.7rem 1.4rem';
      return '0.45rem 0.9rem';
    }};
    font-size: ${props => {
      if (props.size === 'small') return '0.75rem';
      if (props.size === 'medium') return '0.85rem';
      if (props.large) return '0.95rem';
      return '0.825rem';
    }};
  }

  @media (max-width: 992px) {
    padding: ${props => {
      if (props.size === 'small') return '0.3rem 0.65rem';
      if (props.size === 'medium') return '0.45rem 0.9rem';
      if (props.large) return '0.65rem 1.3rem';
      return '0.4rem 0.8rem';
    }};
    font-size: ${props => {
      if (props.size === 'small') return '0.7rem';
      if (props.size === 'medium') return '0.8rem';
      if (props.large) return '0.9rem';
      return '0.775rem';
    }};
  }

  @media (max-width: 768px) {
    padding: ${props => props.large ? '0.6rem 1.2rem' : '0.5rem 1rem'};
    font-size: ${props => props.large ? '0.85rem' : '0.8rem'};
  }

  @media (max-width: 480px) {
    padding: ${props => props.large ? '0.5rem 1rem' : '0.4rem 0.8rem'};
    font-size: ${props => props.large ? '0.8rem' : '0.75rem'};
  }
`;

export default ElevatedButton;